import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import { formatISOToPHT } from '../../../utilities/date';

export const EmployeeTrainingsComponent = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table
          sx={{
            width: '100%',
          }}
        >
          <TableHead>
            <TableRow>
              <CustomTableCell value="Training Title" />
              <CustomTableCell value="Hours" />
              <CustomTableCell value="Start Date" />
              <CustomTableCell value="End Date" />
              <CustomTableCell value="Conducted/Sponsored By" />
            </TableRow>
          </TableHead>
          {props.emptrn?.map((training) => (
            <TableRow key={training._id}>
              <TableCell> {training.trainingtitle} </TableCell>
              <TableCell> {training.hours} </TableCell>
              <TableCell> {formatISOToPHT(training.startdate)} </TableCell>
              <TableCell> {formatISOToPHT(training.enddate)} </TableCell>
              <TableCell> {training.sponsor} </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
